<template>

    <div class="checklist-maker-step-2">

        <b-form validated horizontal>

            <b-form-group label="Checklist Title">
                <b-form-input required
                              v-model="docData.cardTitle">
                </b-form-input>
            </b-form-group>

            <b-form-group label="Student Name">
                <b-form-input required
                              v-model="docData.studentName">
                </b-form-input>
            </b-form-group>


        </b-form>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ChecklistMakerStep2",
        mixins: [ToolMixin],
        // data() {
        //
        // },
        computed: {
            thisStepIsValid() {
                return this.docData.cardTitle != null
                    && this.docData.studentName != null
            }
        }
    })

</script>
